import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import { Button } from 'sarsaparilla';
import { AssetProps } from '../../props/asset';
import EventEdit from './EventEdit';
import { EventDefaults, EventProps } from '../../props/event';
import { getEvents } from '../../reducers/events';
import { getState } from '../../reducers';
import LoadingWrapper from '../../../../ui-lottery/src/components/LoadingWrapper';

import pageStyles from '../../containers/StewardAssetEditPage/StewardAssetEditPage.scss';
import { STATE_READY } from '../../../../ui-lottery/src/utils/async_utils';
import { fetchEvents, resetEvents } from '../../actions/events';

const propTypes = {
  eventsToLoad: PropTypes.bool,
  asset: AssetProps,
  value: PropTypes.arrayOf(EventProps),
  eventType: PropTypes.string,
  states: PropTypes.objectOf(PropTypes.number),
  fetchData: PropTypes.func.isRequired,
  resetEvents: PropTypes.func.isRequired
};

const defaultProps = {
  value: []
};

export class EventsTab extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      events: []
    };

    this.addEvent = this.addEvent.bind(this);
    this.removeEvent = this.removeEvent.bind(this);
  }

  componentDidMount() {
    if (this.props.eventsToLoad) {
      this.props.fetchData();
    }
  }

  componentWillUnmount() {
    this.props.resetEvents();
  }

  componentDidUpdate() {
    if (this.props.eventsToLoad && this.state.events.length === 0 && this.props.value) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ events: this.props.value });
    }
  }

  addEvent() {
    const event = { ...EventDefaults, _key: uniqueId('event-') };

    this.setState((prevState) => ({ ...prevState, events: [...prevState.events, event] }));
  }

  removeEvent(key) {
    this.setState((prevState) => ({
      ...prevState,
      events: prevState.events.filter((event) => event._key !== key)
    }));
  }

  render() {
    const { eventsToLoad, states: { events }, eventType } = this.props;
    const loading = eventsToLoad && events !== STATE_READY;

    return (
      <LoadingWrapper loading={loading} size="large">
        <div className={pageStyles['tab-body']}>
          {this.state.events.map((event) => (
            <EventEdit
              key={event._key}
              value={event}
              eventType={eventType}
              onRemove={this.removeEvent} />
          ))}
          <Button onClick={this.addEvent}>
            Add Event
          </Button>
        </div>
      </LoadingWrapper>
    );
  }
}

EventsTab.propTypes = propTypes;
EventsTab.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    value: getEvents(state),
    states: getState(state, 'events')
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchData: () => dispatch(fetchEvents(ownProps.assetType, ownProps.asset.id, {})),
    resetEvents: () => dispatch(resetEvents())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventsTab);
